import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5 16.19h10c.797 0 1.56-.304 2.122-.848.563-.543.879-1.28.879-2.048V5.087c0-.768-.316-1.505-.879-2.048a3.06 3.06 0 0 0-2.121-.848H5c-.796 0-1.559.305-2.121.848A2.85 2.85 0 0 0 2 5.087v8.207c0 .769.317 1.505.88 2.048a3.06 3.06 0 0 0 2.12.849M4 5.088a.95.95 0 0 1 .294-.682c.187-.181.442-.283.707-.283h10c.265 0 .52.102.707.283a.95.95 0 0 1 .293.682v.435l-4.768 3.287a2.2 2.2 0 0 1-1.232.375c-.441 0-.871-.13-1.233-.375L4.001 5.522zm0 2.808 3.606 2.486a4.22 4.22 0 0 0 2.395.741c.859 0 1.696-.26 2.395-.741L16 7.895v5.4a.95.95 0 0 1-.293.682 1.02 1.02 0 0 1-.707.283H5c-.265 0-.52-.102-.707-.283A.95.95 0 0 1 4 13.294z"
    }, null, -1)
  ])))
}
export default { render: render }